import React from 'react'
import { Typography, Grid, Box, StepLabel, StepContent } from '@mui/material'

import { I18n } from '@front/volcanion/'

import {
  TextField,
  MenuSelectorField,
  SingleOptionSelectorField,
  NumberField,
} from '@front/squirtle/'

const Row1 = (props, context) => {

  return (
    <Grid container spacing={1} alignItems='flex-end' size={12}>
      <Grid size="grow">
        <TextField
          name={'name'}
          label={I18n.t('name.label', { count: 1 })}
          required
        />
      </Grid>
      <Grid size="grow">
        <TextField
          name='authorized_phone_number'
          label={I18n.t('phone.authorized')}
        />
      </Grid>
      <Grid size="grow">
        <TextField
          name='schedule_delay'
          label={I18n.t('commercial_formula.schedule_delay')}
          type='number'
          emptyValue='-'
          InputProps={{
            inputProps: { style: { textAlign: 'right' } }
          }}
          required
        />
      </Grid>
    </Grid>
  );
}

const Row2 = (props, context) => {

  return (
    <Grid container spacing={1} alignItems='flex-end' size={12}>
      <Grid size="grow">
        <TextField
          name='label_for_call_center'
          label={I18n.t('display.operator.one')}
          required
        />
      </Grid>
      <Grid size="grow">
        <TextField
          name='label_for_driver'
          label={I18n.t('display.driver.one')}
          required
        />
      </Grid>
    </Grid>
  );
}

const Row3 = ({ delayAtSourceType, delayAtSourceOptions, onDelayAtSourceTypeChange }) => {
  return (
    <Grid container spacing={1} alignItems='flex-end' size={12}>
      <Grid size={6}>
        <MenuSelectorField
          name='ivr_access'
          label={I18n.t('ivr.access')}
          options={[
            { label: I18n.t('ivr_access.never'), value: '0' },
            { label: I18n.t('ivr_access.yes_if_order'), value: '1' },
            { label: I18n.t('ivr_access.yes_without_limit'), value: '2' }
          ]}
          required
        />
      </Grid>
      <Grid size={3}>
        <MenuSelectorField
          name={'delayAtSourceType'}
          label={I18n.t('driver.waiting')}
          options={delayAtSourceOptions}
          afterChange={onDelayAtSourceTypeChange}
          alwaysInclude
          required
        />
      </Grid>
      <Grid hidden={delayAtSourceType === 'default'} size={3}>
        <NumberField
          label={I18n.t('driver.waiting_delay')}
          name={'delay_at_source'}
          type='number'
          minValue={0}
          required={delayAtSourceType === 'custom'}
          InputProps={{ endAdornment: 'min' }}
        />
      </Grid>
    </Grid>
  );
}
const Row4 = (props, context) => {

  return (
    <Grid container spacing={1} alignItems='flex-end' size={12}>
      <Grid size="grow">
        <TextField
          name='dispatch_priority'
          label={I18n.t('priority.dispatching.other')}
          required
        />
      </Grid>
      <Grid size="grow">
        <TextField
          name='display_index'
          label={I18n.t('display.index')}
          type='number'
        />
      </Grid>
      <Grid size="grow">
        <TextField
          name='fixed_fee'
          label={I18n.t('bank.fixed_fee')}
          InputProps={{
            endAdornment: <Box> {I18n.t('fiat.eur.sign')} </Box>
          }}
          required
        />
      </Grid>
      <Grid size="grow">
        <TextField
          name='fee_rate'
          label={I18n.t('bank.fee_rate')}
          InputProps={{
            endAdornment: <Box> {I18n.t('prefix.percent')} </Box>
          }}
          required
        />
      </Grid>
      <Grid size={1}>
        <SingleOptionSelectorField
          name='deferred_invoicing_or_inapp_invoice'
          label={I18n.t('commercial_formula.deferred_invoicing_or_inapp_invoice')}
        />
      </Grid>
      <Grid size={1}>
        <SingleOptionSelectorField
          name='is_given_priority_for_incident_processing'
          label={I18n.t('priority.incident.other')}
        />
      </Grid>
      <Grid size={1}>
        <SingleOptionSelectorField
          name='is_authorized'
          label={I18n.t('commercial_formula.is_authorized')}
        />
      </Grid>
    </Grid>
  );
}

const PrimarySection = (props) => <>
  <StepLabel>
    <Typography variant='h5'>{I18n.t('info.general')}</Typography>
  </StepLabel>
  <StepContent >
    <Box sx={{ p: 2, boxShadow: 6, borderRadius: 1 }}>
      <Grid container rowSpacing={3}>
        <Row1 {...props} />
        <Row2 {...props} />
        <Row3 {...props} />
        <Row4 {...props} />
      </Grid>
    </Box>
  </StepContent>
</>

export default React.memo(PrimarySection)
